import { axiosRef } from '../../../api';
import { lmsLocationPayload } from '../interfaces';

export default async function getLmsLocations(
  payload: lmsLocationPayload,
  isAdmin: boolean,
  setLoading: (loading: boolean) => void,
) {
  setLoading(true);

  let url = `business_central/lms/location_list`;

  if (isAdmin && payload && payload?.jobNo) {
    url = url + `job_no=${payload.jobNo}`;
  }

  try {
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const lmsLocations = response.data.content.map((datum: any): any => ({
        label: datum?.name,
        value: datum?.code,
      }));

      return {
        lmsLocations,
      };
    }
    setLoading(false);
    return {
      lmsLocations: [],
    };
  } catch (error) {
    setLoading(false);
    return {
      lmsLocations: [],
    };
  }
}
